
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const features = [
  {
    title: "Sve informacije na jednom mestu",
    desc: "Pregled vozila, vozača i putnih naloga iz jednog sistema.",
  },
  {
    title: "Brže kreiranje i praćenje naloga",
    desc: "Jednostavno upravljanje svakodnevnim aktivnostima.",
  },
  {
    title: "Kontrola troškova",
    desc: "Praćenje potrošnje goriva, servisa i ostalih troškova.",
  },
  {
    title: "Pravovremeni podsetnici",
    desc: "Registracije i servisni intervali nikada neće biti propušteni.",
  },
];

export default function WhyTrackFleet() {
  return (
    <Box
      sx={{
        py: 15,
        bgcolor: "#0d2a4a",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={10} alignItems="center">
          {/* Leva strana */}
          <Grid item xs={12} md={5}>
            <Typography
              variant="overline"
              color="success.main"
              sx={{ letterSpacing: 2 }}
            >
              ZAŠTO TRACKFLEET DMS?
            </Typography>

            <Typography
              variant="h3"
              fontWeight={700}
              color="white"
              mt={2}
              mb={3}
            >
              Jednostavnije upravljanje voznim parkom,
              manje vremena sa administracijom.
            </Typography>

            <Typography
              color="grey.400"
              sx={{
                lineHeight: 1.9,
                fontSize: "1.1rem",
              }}
            >
              Sistem objedinjuje putne naloge, vozila i troškove na jednom
              mestu, kako biste imali potpunu kontrolu nad poslovanjem.
            </Typography>
          </Grid>

          {/* Desna strana */}
          <Grid item xs={12} md={7}>
            <Grid container spacing={3}>
              {features.map((feature) => (
                <Grid item xs={12} sm={6} key={feature.title}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 4,
                      height: "100%",
                      borderRadius: 5,
                      bgcolor: "rgba(255,255,255,0.03)",
                      border: "1px solid rgba(255,255,255,0.08)",
                      transition: "all .25s ease",

                      "&:hover": {
                        transform: "translateY(-6px)",
                        borderColor: "#22c55e",
                        boxShadow: "0 0 30px rgba(34,197,94,.15)",
                      },
                    }}
                  >
                    <CheckCircleOutlineIcon
                      color="success"
                      sx={{ fontSize: 32, mb: 2 }}
                    />

                    <Typography
                      color="white"
                      fontWeight={600}
                      mb={1}
                      variant="h6"
                    >
                      {feature.title}
                    </Typography>

                    <Typography color="grey.400">
                      {feature.desc}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}